import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
    Container,
    Header,
    Content,
    Footer,
    Sidebar as Side } from 'rsuite';
import {
    Button,
    Popup } from 'semantic-ui-react'
import { api } from '../../../services/api';
import moment from 'moment';

import Navbarr from '../../../components/Navbar';
import CardTable from '../../../components/CardTable';

import './styles.css';

export default function StoreList({ sidebar: Sidebar}) {
    const history = useHistory();
    const [storeStates, setStoreStates] = useState({
        isLoadingData: true,
        lastUpdate: "",
        reloadControl: false,
    });

    const [tableData, setTableData] = useState({
        columns: [
            {
                label: 'Nome',
                field: 'nome',
                sort: 'asc',
                width: 400
            },
            {
                label: 'Endereço',
                field: 'endereco',
                sort: 'asc',
                width: 400
            },
            {
                label: 'Produtos',
                field: 'produtosQtd',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Rotas',
                field: 'rotasQtd',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Ações',
                field: 'acao',
                sort: 'asc',
                width: 100
            }

        ],
        rows: [],
    });

    const updateStoresData = () => {
        setStoreStates( state => ({
            ...state,
            reloadControl: !state['reloadControl'],
        }));
    }

    useEffect(() => {
        const goToStoreEditScreen = (e, store, index) => {
            e.preventDefault();
            history.push(`/stores/${store['id']}`, {storeId: store['id']});
        }

        const changeStoreForTable = (store, index) => {
            store['produtosQtd'] = store['produtos'].length;
            store['rotasQtd'] = store['rotas'].length;
            store['acao'] = <Popup content='Visualizar'
                trigger={
                    <Button basic size='mini' icon='eye' onClick={(e) => goToStoreEditScreen(e, store, index)} />
                } />

            return store;
        }

        async function fetchStores() {
            setStoreStates( state => ({
                ...state,
                isLoadingData: true
            }));
            try {
                let data = await api.getStores();
                data.forEach((element, index) => { changeStoreForTable(element, index)});

                setTableData( state => ({
                  ...state,
                  rows: data
                }));

                setStoreStates( state => ({
                    ...state,
                    isLoadingData: false,
                    lastUpdate: moment().format('LT')
                }));
            } catch (err) {
              console.error("Falha ao obter lojas: ", err);
            }
        }

        fetchStores();
    },[storeStates.reloadControl, history]);

    return (
        <Container className="s-content">
            <Side style={{ flex: '0 0 auto', width: 'auto'}}>
                <Sidebar page={"storelist"}></Sidebar>
            </Side>
            <Container>
                <Header>
                    <Navbarr></Navbarr>
                </Header>
                <Content style={{ backgroundColor: '#FAFAFA', padding: '5px'}}>
                    <CardTable
                        type={'store'}
                        data={tableData}
                        tableTitle={"Lojas Cadastradas"}
                        elementsName={"lojas"}
                        isLoadingData={storeStates['isLoadingData']}
                        lastUpdate={storeStates['lastUpdate']}
                        updateData={updateStoresData}
                    />
                </Content>
                <Footer></Footer>
            </Container>
        </Container>
    )
}
